import { Injectable } from '@angular/core';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SearchParams } from '../../../../shared/search/models/search-params.model';
import { DataTableConfig } from '../../../../shared/search/models/data-table-config';
import { ReportsConfigurationDataService } from './reports-configuration-data.service';
import { DetailedEntityDataEditorService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { SearchCriteria, Clause } from '../../../../shared/search/models/search-filter-model';

@Injectable()
export class ReportsConfigurationDataEditorService extends DetailedEntityDataEditorService {

  protected dataService: ReportsConfigurationDataService;
  private detailMetaData: any;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  // overriden method - for storer and facility lookup to create default search criteria
  protected createDefaultSearchCriteria(currentRow: any, selectedColumnValue: any, property: any) {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition = this.createSearchCondition(1);
    defaultCondition.isMandatory = true;
    defaultCondition.isReadOnly = true;
    const defaultClause = new Clause();
    defaultClause.operation = '=';
    if (property === 'storerKey' || property === 'storerName') {
      defaultClause.column = 'storerType';
      defaultClause.value = '1';
    } else if (property === 'facility') {
      defaultSearchCriteria.conditions = [];
      return defaultSearchCriteria;
    }
    defaultCondition.clauses = [defaultClause];
    defaultCondition.operator = 'AND';
    defaultSearchCriteria.conditions.push(defaultCondition);

    return defaultSearchCriteria;
  }

  // overriden method - for storer and facility lookup to get the lookup ttle from resource bundle
  protected getLookupModalTitle(property) {
    switch (property) {

      case 'storerKey': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('storer_Id'));

      case 'facility': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('facility'));

      default: return property;
    }
  }
  //[LFWM-1984][Lookup screens search accordion][Added funtion to map subtitle in lookup component]
  protected getLookupModalSubTitle(property) {  
    switch (property) {
      case 'storerKey': return this.resourceService.get('storer_Id').concat(' ').concat(this.resourceService.get('lbl_search'));
      case 'facility': return this.resourceService.get('facility').concat(' ').concat(this.resourceService.get('lbl_search'));
      default: return property;
    }
  }
  // overriden method - for storer and facility lookup to specify the tableid to get fetch metadata and loadbypage call
  public createLookupParamsForColumn(property: any): SearchParams {
    const lookupParams = new SearchParams();
    lookupParams.isFullFetch = true;
    lookupParams.columnCount = 10;
    lookupParams.defaultSearchColumn = '';
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.showIdAsAHyperLink = true;
    tableConfig.supportFiltering = true;
    lookupParams.dataTableConfig = tableConfig;
    if (property === 'storerKey' || property === 'storerName') {
      lookupParams.tableId = 'storertd';
      lookupParams.idProperty = 'storerName';
    } else if (property === 'facility') {
      lookupParams.tableId = 'facilitytd';
      lookupParams.idProperty = 'facility';
    }
    return lookupParams;
  }

  // overriden method - for storer and facility lookup to populate the lookup table value to detail table lookup field
  protected getDependantMapForProperty(property: string) {
    let propMap: any;
    if (property === 'storerKey') {
      propMap = {
        'storerKey': 'storerName'
      };
    } else if (property === 'facility') {
      propMap = {
        'facility': 'facility'
      };
    } else {
      return super.getDependantMapForProperty(property);
    }
    return propMap;
  }

  // overriden method - for storer and facility lookup to mention which proprty should focus next.
  protected getNextPropertyToFocus(property: string) {
    switch (property) {

      case 'storerKey': return 'facility';

      default: return property;
    }
  }
  public valueChanged(property, prevVal, currentValue) {
    if (property === 'storerKey') {
      this.detailMetaData = this.dataService.detailsSearchService.getMetadata().columnList;
      this.populateDropdownValuesBasedOnStorer(currentValue);
    }
  }
  public populateDropdownValuesBasedOnStorer(storer: any) {
    const storerKey = storer;
    const metaDataMap = this.detailMetaData;
    for (const key in metaDataMap) {
      if (metaDataMap[key].type === 'DROPDOWN' || metaDataMap[key].type === 'EDITABLEDROPDOWN') {
        if (!metaDataMap[key].originalCoptions) {
          metaDataMap[key].originalCoptions = metaDataMap[key].values;
        }
        // tslint:disable-next-line:max-line-length
        this.detailMetaData[key].cOptions = metaDataMap[key].values = this.getValuesBasedOnStorerForReportConfiguration(metaDataMap[key].originalCoptions, storerKey);
      }
    }
  }
  // [LFWM-2923] - filtering the dropdown values based on storer
  public getValuesBasedOnStorerForReportConfiguration(originalCoptions: any, storer: any) {
    const storerKey = storer;
    let filteredCoptions;
    if (storerKey) {
      filteredCoptions = originalCoptions.filter(element => element.storerkey &&
        element.storerkey.toUpperCase() === storerKey.cVal.trim().toUpperCase());
      if (filteredCoptions.length > 0) {
        filteredCoptions.unshift({ key: '', value: '- Select -', storerkey: null, userDefineValues: null });
      }
    }
    if (!filteredCoptions || filteredCoptions.length === 0) {
      filteredCoptions = originalCoptions.filter(element => !element.storerkey);
    }
    if (filteredCoptions.length === 1 && filteredCoptions[0].key === '' &&
        filteredCoptions[0].value.toLowerCase() === '- select -') {
        filteredCoptions = [];
    }
    return filteredCoptions;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/reports-configuration/services/reports-configuration-data-editor.service.ts